import {
	AfterViewInit,
	Component,
	ElementRef,
	Input,
	OnDestroy,
	ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import { HubspotUtil } from 'app/utils/hubspot/hubspot.util';
import { PromptuarySidebarService } from 'modules/promptuary/services/sidebar/promptuary-sidebar.service';
import { IAppointment } from 'modules/video-conference/interfaces/appointment.interface';
import { JitsiService } from 'modules/video-conference/services/jitsi/jitsi.service';

@Component({
	selector: 'vc-jitsi',
	templateUrl: './vc-jitsi.component.html',
	styleUrls: ['./vc-jitsi.component.scss'],
})
export class VCJitsi implements AfterViewInit, OnDestroy {
	private jitsiService: JitsiService;
	loading = true;

	@ViewChild('jitsiElement') jitsiElement: ElementRef<HTMLInputElement>;
	@Input() private appointment: IAppointment;

	constructor(
		private promptuarySidebarService: PromptuarySidebarService,
		private actionTrackerService: ActionTrackerService,
		private router: Router
	) {}

	ngAfterViewInit() {
		this.jitsiService = new JitsiService(
			this.jitsiElement,
			this.appointment,
			this.stopLoading.bind(this),
			this.actionTrackerService,
			this.promptuarySidebarService,
			this.router
		);
		HubspotUtil.widget.hide();
	}

	ngOnDestroy() {
		HubspotUtil.widget.show();
	}

	stopLoading() {
		this.loading = false;
	}
}
